var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-builder",class:{ 'is-loading': _vm.isLoading }},[_c('transition',{attrs:{"name":"fade"}},[(_vm.pageBuilder)?_c('div',{staticClass:"page-builder-content"},_vm._l((_vm.pageBuilder.rows),function(row){return _c('page-builder-row',{key:row.uuid,attrs:{"row":row}})}),1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476fa0b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/apps/booking/components/pageBuilder/PageBuilder.html
// module id = null
// module chunks = 